import { DynamicHero } from '@cwp/amp-microsites/build/components.es.js'
import { reactToCwp } from '../../../../../common/react-utils'

export default reactToCwp(DynamicHero)
